import { createTheme, type MantineColorsTuple } from '@mantine/core';

/**
 * Тема Mantine. Все цвета интерфейса (фон, поверхности, линии, текст) заданы
 * переменными в global.css — здесь только палитры для компонентов Mantine.
 */

/** Акцент: сине-фиолетовый — выделение, фокус, активный пункт меню. */
const accent: MantineColorsTuple = [
  '#eeefff',
  '#dcdeff',
  '#b8bbff',
  '#9397ff',
  '#7a7cff',
  '#6b6bfa',
  '#5f5cf0',
  '#4f4bd6',
  '#4541bf',
  '#3833a3'
];

/** Проведение: изумрудный — главная кнопка экрана. */
const go: MantineColorsTuple = [
  '#e3fbef',
  '#cdf4e0',
  '#9de8c2',
  '#69dba1',
  '#40d086',
  '#26c974',
  '#14c26a',
  '#05a957',
  '#00964c',
  '#00813f'
];

/** Тёмная палитра Mantine под нейтральные тона приложения (без синевы). */
const dark: MantineColorsTuple = [
  '#ececef',
  '#c9ccd2',
  '#9da2ab',
  '#7c818b',
  '#30333a',
  '#25272c',
  '#1b1d21',
  '#131417',
  '#0e0f11',
  '#08090a'
];

const font = "'Golos Text Variable', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif";

export const theme = createTheme({
  primaryColor: 'accent',
  primaryShade: { light: 6, dark: 5 },
  colors: { accent, go, dark },
  fontFamily: font,
  headings: { fontFamily: font, fontWeight: '600' },
  fontSizes: { xs: '12px', sm: '13px', md: '14px', lg: '16px', xl: '20px' },
  radius: { xs: '4px', sm: '6px', md: '8px', lg: '12px', xl: '16px' },
  defaultRadius: 'md',
  fontSmoothing: true,
  cursorType: 'pointer',
  focusRing: 'auto',
  components: {
    Button: { defaultProps: { size: 'sm' } },
    TextInput: { defaultProps: { size: 'sm' } },
    Select: { defaultProps: { size: 'sm', comboboxProps: { shadow: 'lg' } } },
    Tooltip: { defaultProps: { openDelay: 350, withArrow: true, arrowSize: 6 } },
    Modal: { defaultProps: { radius: 'lg', overlayProps: { backgroundOpacity: 0.55, blur: 3 } } },
    Drawer: { defaultProps: { overlayProps: { backgroundOpacity: 0.45, blur: 2 } } },
    Menu: { defaultProps: { shadow: 'lg', radius: 'md' } },
    Popover: { defaultProps: { shadow: 'lg', radius: 'md' } }
  }
});
